import '../InstallerPanel.css';

import { CSSProperties, ClassNameMap } from '@material-ui/core/styles/withStyles';
import React, { ChangeEvent } from 'react';
import { addSystemGroup, closeNotification } from '../../../stores/actions/installerActions';
import SystemIcon from '../../../components/ShortStatus/SystemIcon';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody';
import CardHeader from '../../../../components/Card/CardHeaderTS';
import CardIcon from '../../../../components/Card/CardIcon';
import Loading from '../../../components/Loading/Loading';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from 'react-redux';
import { emptyHeaderStyle } from '../../../helpers/CustomStyles';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import utils from '../../../helpers/GlobalVariables';

const inputStyle: CSSProperties = {
	flexBasis: '33%',
	paddingRight: '20px',
	minWidth: '200px',
	flexGrow: 1,
	transition: '0.3s',
	marginBottom: '21px',
};

interface ICreateSystemGroupFormProps {
	classes: ClassNameMap;
	disableSystemGroupSubmit: boolean;
	mobileView: boolean;
	systemGroupSaveFail: boolean;
	systemGroupSaveSuccessfully: boolean;
	addSystemGroup: (systemName: string, isPublic: boolean) => void;
	closeNotification: () => void;
}
interface ICreateSystemGroupFormState {
	name: string;
	systemGroupNameValue: string;
	systemGroupNameError: boolean;
    isPublicValue: boolean;
}

class CreateSystemGroupForm extends React.Component<ICreateSystemGroupFormProps, ICreateSystemGroupFormState> {
	state = {
		name: '',
		systemGroupNameValue: '',
		systemGroupNameError: false,
        isPublicValue: true
	};
	closeNotificationTimer = null;

	componentWillMount() {
		this.props.closeNotification();
	}

	componentDidMount() {
		const { systemGroupSaveFail, systemGroupSaveSuccessfully, closeNotification } = this.props;
		if (systemGroupSaveFail || systemGroupSaveSuccessfully) {
			closeNotification();
		}
	}

	componentDidUpdate() {
		const { systemGroupSaveFail, systemGroupSaveSuccessfully, closeNotification } = this.props;
		if (systemGroupSaveFail || systemGroupSaveSuccessfully) {
			this.closeNotificationTimer = setTimeout(closeNotification, 6000);
		}
	}

	componentWillUnmount() {
		clearTimeout(this.closeNotificationTimer);
		this.closeNotificationTimer = null;
	}

	handleInputChange = (e: ChangeEvent): void => {
		const currentValue = (e.target as HTMLInputElement).value;
		const containsIncorrectSigns = utils.validateInputChars(currentValue);

		this.setState({ systemGroupNameError: containsIncorrectSigns, systemGroupNameValue: currentValue });
	};

    handleRadioChange = (event) => {
        console.log(event.target.value)
        this.setState({ isPublicValue: event.target.value === 'public' });
    };

	button = (): JSX.Element => {
		const { disableSystemGroupSubmit, systemGroupSaveFail, systemGroupSaveSuccessfully } = this.props;
		const { systemGroupNameError, systemGroupNameValue } = this.state;
		if (disableSystemGroupSubmit) {
			return (
				<div style={{ width: '100%', marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
					<Loading transform={1} height={17} width={40} color='darkGray' />
				</div>
			);
		}
		return (
			<div style={{ width: '100%' }}>
				<Button
					style={{ marginTop: systemGroupNameError ? '5px' : '25px', transition: 'color 0.3s' }}
					disabled={
						disableSystemGroupSubmit
						|| systemGroupNameError
						|| !systemGroupNameValue.length
						|| systemGroupSaveFail
						|| systemGroupSaveSuccessfully
					}
					data-testid='createSystemGroupButton'
					onClick={(e) => {
						const name = (document.getElementById('system_name') as HTMLInputElement).value.trim();
						if (name !== null) {
							this.setState({ name: name });
							this.props.addSystemGroup(systemGroupNameValue, this.state.isPublicValue);
						}
					}}
				>
					Create
				</Button>
			</div>
		);
	};

	renderMobileNotifications = (): JSX.Element => {
		const { systemGroupSaveFail, systemGroupSaveSuccessfully, mobileView } = this.props;
		const headerStyle = utils.getHeaderStyle(systemGroupSaveFail);

		if (!mobileView) return null;
		if (systemGroupSaveFail || systemGroupSaveSuccessfully) {
			return (
				<h5
					className={systemGroupSaveFail ? 'notification-open-create-system-fail' : 'notification-open-create-system-success'}
					style={headerStyle}
				>
					{systemGroupSaveFail
						? 'The system group could not be created. Maybe a group with the specified name already exists. '
						: 'System group created successfully.'}
				</h5>
			);
		}
		return <div style={emptyHeaderStyle}></div>;
	};


	render() {
		const { classes, closeNotification, disableSystemGroupSubmit, mobileView, systemGroupSaveFail, systemGroupSaveSuccessfully } = this.props;
		const {
			systemGroupNameError,
			systemGroupNameValue,
			name,
		} = this.state;
		return (
			<Card className='createSystemGroupForm'>
				<CardHeader color='info' icon>
					<CardIcon color='info'>
						<SystemIcon />
					</CardIcon>
					<h4 className={classes.cardIconTitle}>Create System Group</h4>
				</CardHeader>
				<CardBody>
					<form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', flexWrap: 'wrap' }}>
						<TextField
							label='Group name'
							id='system_name'
							inputProps={{
								disabled: disableSystemGroupSubmit,
								value: systemGroupNameValue,
								maxLength: utils.defaultMaxInputLength,
								autoCapitalize: 'off',
							}}
							style={{ ...inputStyle, flexBasis: mobileView ? '50%' : '33%' }}
							onChange={(e) => this.handleInputChange(e)}
							error={systemGroupNameError}
							helperText={systemGroupNameError ? 'Incorrect name. Characters not allowed: <, >, /, \\, &, ; ' : ''}
						>
							{name}
						</TextField>
                        <RadioGroup
                            row
                            aria-labelledby="demo-form-control-label-placement"
                            name="position"
                            defaultValue="public"
                        >
                            <FormControlLabel
                                value="private"
                                control={<Radio onChange={(event) => this.handleRadioChange(event)} />}
                                label="Private"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="public"
                                control={<Radio onChange={(event) => this.handleRadioChange(event)} />}
                                label="Public"
                                labelPlacement="start"
                            />

                        </RadioGroup>
						{this.renderMobileNotifications()}
						{this.button()}
					</form>
				</CardBody>
				{!mobileView ? (
					<Snackbar
						close={true}
						closeNotification={() => closeNotification()}
						color={systemGroupSaveFail ? 'danger' : 'success'}
						message={
							systemGroupSaveFail
								? 'The system group could not be created. Maybe a group with the specified name already exists.'
								: 'System group created successfully.'
						}
						open={systemGroupSaveFail || systemGroupSaveSuccessfully}
						place='tc'
					/>
				) : null}
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		disableSystemGroupSubmit: state.dashboard.disableSystemGroupSubmit,
		systemGroupSaveSuccessfully: state.dashboard.systemGroupSaveSuccessfully,
		systemGroupSaveFail: state.dashboard.systemGroupSaveFail,
		mobileView: state.dashboard.mobileView,
	};
};

const actions = { addSystemGroup, closeNotification };
const CreateSystemGroupFormWithStyles = regularFormsStyle(CreateSystemGroupForm);

export default connect(mapStateToProps, actions)(CreateSystemGroupFormWithStyles);
